module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVQ4T2NgGBTgi4b5f3LwcDLgP5lgEBnAsODBf7LwcDJgSAMAYHK1IM3FSrIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/LU.png
// module id = 1197
// module chunks = 0